import { render, staticRenderFns } from "./NsSocialIcons.vue?vue&type=template&id=3308378c&scoped=true&"
import script from "./NsSocialIcons.vue?vue&type=script&lang=js&"
export * from "./NsSocialIcons.vue?vue&type=script&lang=js&"
import style0 from "./NsSocialIcons.vue?vue&type=style&index=0&id=3308378c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3308378c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3308378c')) {
      api.createRecord('3308378c', component.options)
    } else {
      api.reload('3308378c', component.options)
    }
    module.hot.accept("./NsSocialIcons.vue?vue&type=template&id=3308378c&scoped=true&", function () {
      api.rerender('3308378c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsSocialIcons.vue"
export default component.exports